/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PolygonGeometry } from './PolygonGeometry';
import {
    PolygonGeometryFromJSON,
    PolygonGeometryFromJSONTyped,
    PolygonGeometryToJSON,
} from './PolygonGeometry';

/**
 * 
 * @export
 * @interface PortExtendedInnerInner
 */
export interface PortExtendedInnerInner {
    /**
     * 
     * @type {number}
     * @memberof PortExtendedInnerInner
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PortExtendedInnerInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PortExtendedInnerInner
     */
    terminalType?: string;
    /**
     * 
     * @type {PolygonGeometry}
     * @memberof PortExtendedInnerInner
     */
    polygon?: PolygonGeometry;
}

/**
 * Check if a given object implements the PortExtendedInnerInner interface.
 */
export function instanceOfPortExtendedInnerInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortExtendedInnerInnerFromJSON(json: any): PortExtendedInnerInner {
    return PortExtendedInnerInnerFromJSONTyped(json, false);
}

export function PortExtendedInnerInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortExtendedInnerInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'terminalType': !exists(json, 'terminal_type') ? undefined : json['terminal_type'],
        'polygon': !exists(json, 'polygon') ? undefined : PolygonGeometryFromJSON(json['polygon']),
    };
}

export function PortExtendedInnerInnerToJSON(value?: PortExtendedInnerInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'terminal_type': value.terminalType,
        'polygon': PolygonGeometryToJSON(value.polygon),
    };
}

